export enum SealAppType {
  Gate = 'GATE',
  Dock = 'DOCK',
}

export enum GateCheckType {
  Immediate = 'IMMEDIATE',
  Separate = 'SEPARATE',
}

export enum NextActionApp {
  Mobile = 'MOBILE',
  Web = 'WEB',
}

export enum GoodsType {
  Customs = 'CUSTOMS_GOODS',
  Dangerous = 'DANGEROUS_GOODS',
  Sealed = 'SEALED_GOODS',
}

export enum TruckLoadingType {
  Side = 'SIDE',
  End = 'END',
  Ground = 'GROUND',
  Rail = 'RAIL',
}

export enum SrtScanningType {
  Off = 'OFF',
  Optional = 'OPTIONAL',
  Mandatory = 'MANDATORY',
}
